export default __webpack_public_path__ + "static/media/infoRed.2f5dc715.svg";